import Wrapper from "../../Layout/Wrapper/wrapper";
import Button from "../../atoms/Button";
import "./styles.scss";

const HeroIndexed = () => {
  return (
    <Wrapper flexDesktop>
      <div>
        <p>Our service simplifies how you apply for US passports. We ensure you:</p>
        <ul>
          <li>understand which application is correct for you,</li>
          <li>exactly how to fill it out, and</li>
          <li>where it must be sent</li>
        </ul>
        <p>By submitting an application with us, you can save time and avoid the stress of filling out your form and making sure you’re sending it to the correct agency.</p>
      </div>
      <div className="HeroIndexed__buttons">
        <Button
          primary
          full
          label={"Apply for My New Passport"}
          link={"/new-passport"}
          dataQa="home-11"
        />
        <Button
          primary
          full
          label={"Renew My Passport"}
          link={"/passport-renewal"}
          dataQa="home-82"
        />
        <Button
          primary
          full
          label={"Replace My Passport"}
          link={"/lost-stolen-passport"}
          dataQa="home-64"
        />
      </div>
    </Wrapper>
  );
};

export default HeroIndexed;
